<template>
  <div
    class="content-delivery-root cp-font-large"
    :class="{ 'callout-expanded': this.expandCallout }"
  >
    <div
      class="visible-expanded-callout rounded-corners uk-padding-bottom uk-width-1-1@s uk-margin-auto-left uk-margin-auto-right uk-width-5-6"
      :class="{ 'button-box-mobile': isMobile }"
    >
      <div class="uk-flex uk-flex-right">
        <a class="close-icon" @click="toggleCallout()"></a>
      </div>
      <div class="padding uk-text-center">
        <p class="content-text-small-margin">{{ $t('contentDelivery.saveAndDeliver') }}</p>
        <a
          id="learnmore-link"
          @click="redirect(learnMoreUrl, 'Learn More')"
          class="cp-text-underline cp-font-medium white-text"
        >{{ $t('general.learnMore') }}</a>
      </div>
    </div>
    <div
      class="uk-box-shadow-medium uk-text-center uk-width-1-1@s uk-margin-auto-left uk-margin-auto-right uk-width-5-6 content-border-radius base-container"
      :class="{
        'container-mobile': isMobile,
        container: !isMobile && (!sharePreview || shareNoteBook),
        'share-container': sharePreview && !shareNoteBook
      }"
    >
      <div class="arrow-down visible-expanded-callout"></div>
      <div class="expand-callout-card visible-collapsed-callout" @click="toggleCallout()">
        <div class="triangle"></div>
        <img class="uk-position-right icon-padding icon" :src="iconInfo"/>
      </div>
      <div class="uk-margin-left uk-margin-right">
        <button
          id="addtolib-btn"
          class="call-to-action-buttons uk-button cp-font-large uk-text-capitalize cp-primary-button uk-width-1-1"
          :class="{
            'add-to-library-button-mobile': isMobile,
            'add-to-library-button': !isMobile
          }"
          @click="addToSLSO(contentDetail.contentId)"
        >{{ $t('contentDelivery.saveToSLSO') }}
        </button>
          <button
            id="download-btn"
            class="call-to-action-buttons download-button uk-button uk-text-capitalize cp-font-large cp-white-button uk-width-1-1"
            @click="downloadResource()"
            v-if="showDownloadButton">
            <spinner v-if="downloading" class="spinner-style uk-align-center uk-text-middle"></spinner>
            <span v-if="!downloading">{{ $t('general.download') }}</span>
          </button>
        <div class="sls-optimized uk-text-center" v-if="slsOptimizedResource">
          {{ $t('contentDelivery.slsOptimized') }}
        </div>
          <social-media-sharing
            v-if="$feature(socialSharing).enabled && !isPendingOrDeclined && !isModeration"
            :contentDetail="contentDetail"
            :isMobile="isMobile">
          </social-media-sharing>
      </div>
    </div>
    <div>
      <div v-if="!slsOptimizedResource">
        <p class="content-label uk-text-center" v-if="!sharePreview && !isMobile">
          {{ $t('contentDelivery.dontHaveNotebook') }}
          <span v-html="downloadATrial"></span>
        </p>
      </div>

    </div>
    <div
      v-if="!sharePreview"
      class="agreement-container uk-width-1-1@s uk-margin-auto-left uk-margin-auto-right uk-width-5-6"
    >
      <p class="terms-text uk-text-center cp-font-small">
        <span v-html="byUsingThis"></span>
      </p>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import deviceDetectionUtil from '../../utils/device-detection-util'
import screen from '../../utils/screen-util'
import environment from '../../plugins/environment'
import * as staticUrls from '../../enums/static-urls'
import Metrics from '../../services/metrics'
import * as event from '../../enums/mixpanel-event'
import downloadService from '../../services/resource-download-service'
import spinner from '../ui-components/spinner/spinner'
import shareLinkIDUtil from '../../utils/share-link-ID-util'
import mixpanel from '../../services/mixpanel'
import socialMediaSharing from '../ui-components/social-media/social-media-sharing'
import {SOCIAL_MEDIA_ICONS} from '../../plugins/feature/feature-list'
import * as route from '../../enums/routes'
import * as misc from '../../enums/misc'
import iconUtil from '../../utils/icon-util'
import * as _ from 'lodash'
import { SLSO } from '../../enums/clients'
import {DEFAULT, EU_REGION1} from '../../enums/regions'

const SLS_OPTIMIZED_FLAG = 'DO_NOT_DOWNLOAD'
export default {
  name: 'content-delivery',
  components: {spinner, socialMediaSharing},
  props: {
    download: {
      type: Boolean,
      default: false
    },
    sharePreview: {
      type: Boolean,
      default: false
    },
    shareNoteBook: {
      type: Boolean,
      default: false
    },
    EUResource: {
      type: Boolean,
      default: false
    },
    contentDetail: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      isMobile: deviceDetectionUtil.isMobile(),
      notebookUrl: staticUrls.NOTE_BOOK_TRIAL,
      smartExchangeTerms: staticUrls.SMART_EXCHANGE_TERMS,
      learnMoreUrl: environment.serviceUrlFor(SLSO),
      downloading: false,
      downloadATrial: this.$t('contentDelivery.downloadATrial'),
      byUsingThis: this.$t('contentDelivery.byUsingThis'),
      socialSharing: SOCIAL_MEDIA_ICONS.name,
      iconInfo: iconUtil.resolve(misc.ICON_INFO)
    }
  },
  computed: {
    ...mapGetters('auth/id', ['authenticated']),
    ...mapGetters([
      'callout',
      'author',
      'keyword',
      'filters',
      'searchTerm',
      'getUserModQueue',
      'accessToken'
    ]),
    expandCallout: {
      get: function () {
        return this.callout
      }
    },
    isModeration() {
      return this.$route.name === route.ROUTE_NAME_MODERATE_RESOURCE
    },
    isPendingOrDeclined() {
      try {
        if (this.$route.name === route.ROUTE_NAME_MYRESOURCE) {
          let status = this.getUserModQueue.find(
            r => r.contentId === this.$route.params.id
          ).status
          if (status === 'PENDING' || status === 'DECLINED') {
            return true
          }
          return false
        }
        return false
      } catch (err) {
        return false
      }
    },
    showDownloadButton() {
      return this.slsOptimizedResource ? false : !this.isMobile && ((this.sharePreview && this.shareNoteBook) || !(this.sharePreview && !this.shareNoteBook))
    },
    slsOptimizedResource() {
      return _.includes(this.contentDetail.externalFlags, SLS_OPTIMIZED_FLAG)
    }
  },
  methods: {
    ...mapActions(['downloadContent']),
    ...mapMutations(['updateCallout']),
    addToSLSO(contentId) {
      Metrics.sendMetric(
        Metrics.CATEGORIES.THIRD_PARTY_CALLS,
        Metrics.CP_TAGS.ADD_TO_SLSO,
        1,
        Metrics.TYPE.OCCURRENCE_COUNTER
      )
      if (this.$feature('import-with-shareid').enabled) {
        window.open(this.resolveSLSOUrl(this.$route.params.id), 'AddToSLSO')
      } else {
        window.open(this.resolveSLSOUrl(contentId), 'AddToSLSO')
      }

      mixpanel.track(event.ADD_TO_LIBRARY_CLICKED, {contentId: contentId})
    },
    resolveSLSOUrl(contentId) {
      let SLSOUrl = environment.serviceUrlFor(SLSO) + '/import/' + contentId
      let params = []
      let referrer = this.getReferrerParam()
      if (referrer) {
        params.push(referrer[0])
      }
      if (
        environment.getEnv() !== 'prod' &&
        environment.getEnv() !== 'preprod'
      ) {
        params.push('env=' + environment.getEnv())
      }
      if (this.EUResource) {
        params.push('srcReg="eu1"')
      }
      if (params.length > 0) {
        let queryString = ''
        for (let value of params) {
          queryString += value + '&'
        }
        SLSOUrl += '?' + queryString.substring(0, queryString.length - 1)
      }
      return SLSOUrl
    },
    /* In some flow Users will land on this page from 3rd party sites like GDrive. SLSO wants to handle those differently so we need to pass along the referrer parameter if it exists */
    getReferrerParam() {
      let referrerParam = new RegExp('referrer=([^&]*)', 'i').exec(
        window.location.search
      )
      return referrerParam
    },
    redirect(url, target) {
      window.open(url, target)
      Metrics.sendMetric(
        Metrics.CATEGORIES.THIRD_PARTY_CALLS,
        Metrics.CP_TAGS.ADD_TO_SLSO,
        1,
        Metrics.TYPE.OCCURRENCE_COUNTER
      )
      if (url === this.learnMoreUrl) {
        mixpanel.track(event.LEARN_MORE_CLICKED, {
          contentId: this.$route.params.id
        })
      } else if (url === this.notebookUrl) {
        mixpanel.track(event.DOWNLOAD_NOTEBOOK_TRIAL_CLICKED, {
          contentId: this.$route.params.id
        })
      } else if (url === this.smartExchangeTerms) {
        mixpanel.track(event.TERMS_CLICKED, {
          contentId: this.$route.params.id
        })
      }
    },
    toggleCallout() {
      if (this.callout) {
        this.updateCallout(false)
      } else {
        this.updateCallout(true)
      }
    },
    downloadResource() {
      Metrics.sendMetric(
        Metrics.CATEGORIES.THIRD_PARTY_CALLS,
        Metrics.CP_TAGS.DOWNLOAD_RESOURCE,
        1,
        Metrics.TYPE.OCCURRENCE_COUNTER
      )
      mixpanel.track(event.DOWNLOAD_CLICKED, {
        contentId: this.$route.params.shareId || this.$route.params.id
      })
      if (this.authenticated || this.shareNoteBook) {
        mixpanel.track(event.DOWNLOADING_RESOURCE, {
          contentId: this.$route.params.shareId || this.$route.params.id
        })
        let region = DEFAULT
        if (this.EUResource) {
          region = EU_REGION1
        }
        let accessToken = null
        if (this.$route.name !== route.ROUTE_NAME_PREVIEW && this.$route.name !== route.ROUTE_NAME_SHARE) {
          accessToken = this.accessToken
          region = environment.getRegion()
        }
        this.downloadContent({
          id: this.contentDetail.contentId,
          shareId: this.$route.params.id,
          region: region,
          accessToken: accessToken
        }).then(url => {
          downloadService
            .initiate(url)
            .then(response => {
              if (navigator.msSaveBlob) {
                navigator.msSaveBlob(response, this.contentDetail.fileName)
              } else {
                this.saveResource(response)
              }
            })
            .progress(progress => {
              if (progress === 100) {
                this.downloading = false
              } else {
                this.downloading = true
              }
            })
        })
      } else {
        let state = {
          from: this.$route.path,
          download: true
        }
        this.$auth.id.signIn(state)
      }
    },
    saveResource(response) {
      let a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      let url = window.URL.createObjectURL(response)
      a.href = url
      a.download = this.contentDetail.fileName
      a.click()
      document.body.removeChild(a)
    },
    resolveWindowWidth() {
      if (screen.resolveWidth() <= 1024) {
        if (this.callout) {
          this.updateCallout(false)
        }
      }
    }
  },
  mounted() {
    this.resolveWindowWidth()
    window.addEventListener('resize', this.resolveWindowWidth)
    let autoDownload = shareLinkIDUtil.resolve(
      this.contentDetail.contentId,
      this.shareNoteBook
    )
    if (this.download || autoDownload) {
      this.downloadResource()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/colours.scss';
@import '../../styles/breakpoints.scss';

.agreement-container {
  max-width: 600px;
}

.content-delivery-root {
  .visible-expanded-callout {
    max-width: 600px;
  }

  .add-to-library-button {
    min-height: 50px;
    margin-top: 20px;
  }

  .add-to-library-button-mobile {
    margin-bottom: 44px;
    height: 50px;
    margin-top: 43px;
  }

  &.callout-expanded {
    .visible-collapsed-callout {
      display: none;
    }

    .content-border-radius {
      border-bottom-left-radius: 2px;
      border-bottom-right-radius: 2px;
    }

    .add-to-library-button {
      margin-top: 43px;
    }

    .content-text-small-margin {
      margin-top: 0px !important;
      margin-bottom: 10px;
    }
  }

  &:not(.callout-expanded) {
    .visible-expanded-callout {
      display: none;
    }

    .add-to-library-button {
      margin-top: 43px;
    }
  }

  .content-border-radius {
    border-radius: 2px;
  }
}

.call-to-action-buttons {
  width: 80%;
  font-weight: bold;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
}

p.content-label {
  margin-top: 32px;
  margin-bottom: 25px;
  font-size: 13px;

  /deep/ a {
    font-weight: bold;
    color: $content-link-blue;
  }
}

div.sls-optimized {
  margin-top: 12px;
  font-size: 14px;
}

div.eu-disabled {
  width: 80%;
  margin-top: 12px;
  font-size: 12px;
  margin-left: auto;
  margin-right: auto;
}

.terms-text {
  margin-top: 7px;

  /deep/ a {
    font-weight: bold;
    color: $content-link-blue;
  }
}

.rounded-corners {
  background-color: $purple;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: white;
}

.padding {
  padding: 0px 23px 25px;
}

.share-container {
  height: 137px;
}

.container {
  min-height: 212px;
}

.base-container {
  max-width: 600px;
  position: relative;
  padding-bottom: 7px;
  background-color: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
}

.container-mobile {
  min-height: 137px;
}

.button-box-mobile {
  height: 137px;
}

.expand-callout-card {
  img {
    padding-top: 4px;
    padding-right: 4px;
  }

  .triangle {
    border-right: 50px solid $purple;
    border-bottom: 50px solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    right: 0px;
  }

  &:hover {
    cursor: pointer;

    .triangle {
      -webkit-filter: drop-shadow(3px 5px 8px rgba(0, 0, 0, 0.24));
      filter: drop-shadow(3px 5px 8px rgba(0, 0, 0, 0.24));
    }
  }
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 45px solid transparent;
  border-right: 45px solid transparent;
  border-top: 30px solid $purple;
  margin-left: calc(50% - 45px);
  margin-top: -2px;
  position: absolute;
}

.white-text,
.uk-icon {
  color: white;
}

.close-icon {
  padding: 18px;
  background: url('../../../static/custom-icons/icon-close-white.svg') no-repeat center;

  &:hover {
    background: url('../../../static/custom-icons/icon-close-white-hover.svg') no-repeat center;
  }
}

.spinner-style {
  max-height: 40px;
  margin-top: 3px;
}

.download-button {
  margin-top: 24px;
}

.disabled-download-button {
  background-color: $app-background;
  color: $light-grey;
  border-radius: 2px;
  border: solid 2px $light-grey;
}

@media screen and (max-width: $breakpoint-small) {
  .terms-text {
    font-size: 12px;
    line-height: normal;
    letter-spacing: normal;
  }
  .expand-callout-card {
    .triangle {
      border-right: 32px solid $purple;
      border-bottom: 32px solid transparent;
    }

    img {
      width: 15px;
      height: 15px;
    }
  }
  .content-delivery-root {
    .add-to-library-button-mobile {
      margin-bottom: 32px;
      margin-top: 32px;
      height: 32px;
      font-size: 14px;
    }

    .call-to-action-buttons {
      width: 253.6px;
    }

    .container-mobile {
      min-height: 96px;
    }
  }
}
</style>
